import React from 'react';
import { Container } from 'react-bootstrap';

const Bcs = () => {
    return (
        <>
                    <Container>
            <table class="table table-hover">
  <thead>
    <tr>
      <th scope="col">#</th>
      <th colspan="2">Book Name</th>
      <th scope="col">Download</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <th scope="row">1</th>
      <td colspan="2">CAO</td>
      <td><a style={{textDecoration:'none'}} href='https://drive.google.com/file/d/1lpVUNkFg8V_eWW7m3rqnvgmjjOXmvZ37/view?usp=sharing' download> Download <i class="fa fa-download" style={{fontSize:'17px'}}></i></a></td>
    </tr>
    <tr>
        <th scope='row'>2</th>
        <td colspan="2">Java The Complete Refrence</td>
        <td><a style={{textDecoration:'none'}} href='https://drive.google.com/file/d/1pxwnj2JZmNb39QQU5xaBZg_iOR5jLnSA/view?usp=sharing' download> Download <i class="fa fa-download" style={{fontSize:'17px'}}></i></a></td>
    </tr>
    <tr>
      <th scope="row">3</th>
      <td colspan="2">SQL The Complete Refrence</td>
      <td><a style={{textDecoration:'none'}} href='https://drive.google.com/file/d/1TR5lShWkw3b5ld4puK0RYhEN8b5tYm6Z/view?usp=sharing' download> Download <i class="fa fa-download" style={{fontSize:'17px'}}></i></a></td>
    </tr>
    <tr>
      <th scope="row">4</th>
      <td colspan="2">HTML The Complete Refrence</td>
      <td><a style={{textDecoration:'none'}} href='https://drive.google.com/file/d/1Mm58pL8V0eR8FeN92yCVgprnTzhsQSjJ/view?usp=sharing' download> Download <i class="fa fa-download" style={{fontSize:'17px'}}></i></a></td>
    </tr>
  </tbody>
</table>
</Container>
        </>
    );
}

export default Bcs;
